import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../../../reusableComponents/allPopupReusable/NotificationButton";
//import LocationReusable from "../../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import EditWaitTime from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import NewCountDown from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import ReadMoreReact from "read-more-react";
import AllActionPopup from "../AllActionPopup/AllActionPopup";
import EnterTableNumber from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";
import EditRsvpOfflineEvent from "./EditRsvpOfflineEvent";
import ViewRsvpOfflineEvent from "./ViewRsvpOfflineEvent";
import LocationReusable from "../../../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";

export const OfflineEventTableBody = (props) => {
  let history = useHistory();
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(props.dinerInfo.wait_time_date);
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = Math.abs(props.dinerInfo.wait_time) * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.dinerInfo.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  const [enterTableModal, setEnterTableModal] = useState(false);
  const setTablePopUp = (e) => {
    console.log(e, "called setTablePopUp");
    setEnterTableModal(true);
  };
  const setTablePopUpClose = (e) => {
    setEnterTableModal(false);
  };
  console.log(enterTableModal);
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [extra, setExtra] = React.useState(
    true
    // props.pathname.includes("offline-events-booked") ||
    //   props.pathname.includes("offline-events-history")
    //   ? true
    //   : false
  );

  const [open, setState] = useState(false);
  const onCloseModal = () => {
    setState(!open);
  };
  // const onSubmitHandlerAssignTable = (e) => {
  //   console.log("test");
  //   const formData = {
  //     event_status: "SEATED",
  //     table_number: 21,
  //   };
  // };

  const token = useSelector((state) => {
    return state.auth.user.accessToken;
  });

  const getSingleEventInfo = useSelector((state) => {
    return state.rsvpEvent.get_single_event_info;
  });

  const onPayNowClick = (data) => {
    console.log(data);
    const formData = {};
    formData.event_id = getSingleEventInfo && getSingleEventInfo._id;
    formData.vendor_id = token;
    formData.restaurant_id =
      getSingleEventInfo && getSingleEventInfo.restaurant_id;
    formData.kids_count = data.kids_count;
    formData.adult_count = data.adult_count;
    formData.handicap_chair = data.handicap_chair;
    formData.high_chair = data.high_chair;
    formData.room_number = data.room_number;
    formData.seat_number = data.seat_number;
    formData.occasion = data.occasion;
    // formData.seating_preference = data.seating_preference;
    // formData.reservationTime = formik.values.reservationDateTime;
    // parseInt(data.wait_time.split("-")[1]);
    formData.event_type = data.event_type;
    formData.event_status = data.event_status;
    // formData.service_type = data.service_type;
    formData.pointOfEntry = data.pointOfEntry;
    formData.user_details = {
      country_code: data.user_details.country_code,
      mobile_number: data.user_details.mobile_number,
      name: data.user_details.name,
    };
    history.push({
      pathname: `/event-payment/${getSingleEventInfo._id}`,
      state: { addGuestInfo: getSingleEventInfo._id, formData: formData },
    });
  };

  return (
    <Fragment>
      {/* <div className="seating-dashboard-body"> */}
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr`}
                  // ${
                  //   //   props.pathname.includes("offline-events-history")
                  //   //     ? "td_b_g"
                  //   //     : "td_b_g"
                  //   // }
                  onClick={showTr}
                >
                  <td
                    className={"order-type-Image p-3 text-center"}
                    style={{ width: "5%" }}
                  >
                    {props.dinerInfo.event_type === "RSVP" ? (
                      <Image
                        src={require("../../../../../../assets/images/seatingImages/happy-new-year.svg")}
                        alt="Order Type"
                        title="Order Type"
                        className="img-fluid"
                      />
                    ) : null ||
                      props.dinerInfo.event_type === "TICKET_BOOKED" ? (
                      <Image
                        src={require("../../../../../../assets/images/seatingImages/movie-seat.svg")}
                        alt="Order Type"
                        title="Order Type"
                        className="img-fluid"
                        style={{ width: 28 }}
                      />
                    ) : null}
                  </td>
                  <td style={{ width: extra ? "18%" : "20%" }}>
                    {/* {console.log(props.dinerInfo)} */}
                    <h4 className="font_20_m">
                      {props.dinerInfo &&
                        props.dinerInfo.user_details &&
                        props.dinerInfo.user_details.name}
                    </h4>
                    <p className="font_12_r">
                      #{props.dinerInfo.event_request_id}
                    </p>
                  </td>
                  <td style={{ width: extra ? "14%" : "12%" }}>
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props.dinerInfo.adult_count +
                              props.dinerInfo.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.adult_count}
                            </p>
                          </div>
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.kids_count}
                            </p>
                          </div>
                        </div>
                        <div className="total-highchair-handicapp">
                          {/* {props.dinerInfo.high_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.high_chair}
                            </p>
                          </div>
                          {/* )}
                    {props.dinerInfo.handicap_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.handicap_chair}
                            </p>
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: extra ? "14%" : "15%" }}>
                    {/* {extra && props.pathname.includes("offline-events-booked") && ( */}
                    <div
                      className="date-time-timer-body"
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                      }}
                    >
                      {/* {props.dinerInfo.event_status === "REJECTED" ||
                      props.dinerInfo.event_status === "CANCELLED" ||
                      props.dinerInfo.event_status === "COMPLETED" ? (
                        <div className="time-and-edit-button">
                          <div className="timer-section mr-2">
                            <h4 className="timer-count">00 : 00 : 00</h4>
                          </div>
                        </div>
                      ) : ( */}
                      <div className="time-and-edit-button">
                        <div className="timer-section mr-2">
                          <h4 className="timer-count">
                            <NewCountDown waitNew={diff} />
                          </h4>
                        </div>
                        {props.dinerInfo.event_status === "REJECTED" ||
                        props.dinerInfo.event_status === "CANCELLED" ||
                        props.dinerInfo.event_status === "COMPLETED" ? (
                          ""
                        ) : (
                          <EditWaitTime
                            allDataProps={props.dinerInfo._id}
                            actionBy="RsvpEvent"
                            status={props.dinerInfo}
                          />
                        )}
                      </div>
                      {/* )} */}
                    </div>
                    {/* )} */}
                    <p className="font_20_r">
                      {moment(
                        props.dinerInfo && props.dinerInfo.updatedAt
                      ).format("Do MMM, YYYY")}
                      <br />
                      {moment(
                        props.dinerInfo && props.dinerInfo.updatedAt
                      ).format("hh:mm A")}
                    </p>
                  </td>
                  {extra && (
                    <td style={{ width: "14%" }}>
                      <div className="w-75 text-center">
                        <div>
                          {props.dinerInfo &&
                          props.dinerInfo.payment_data &&
                          props.dinerInfo.payment_data.total_amount
                            ? `₹ ${props.dinerInfo.payment_data.total_amount}`
                            : ""}
                        </div>
                        {props.dinerInfo &&
                        props.dinerInfo.payment_data &&
                        props.dinerInfo.payment_data.total_amount ? (
                          <hr className="mt-2 mb-2" />
                        ) : (
                          ""
                        )}
                        {props.dinerInfo.event_type === "TICKET_BOOKED" &&
                        props.dinerInfo &&
                        props.dinerInfo.payment_status !== undefined &&
                        props.dinerInfo.payment_status !== null &&
                        props.dinerInfo.payment_status === 0 ? (
                          <div
                            onClick={() => onPayNowClick(props.dinerInfo)}
                            className="enPendingLBLSmall text-capitalized"
                          >
                            PENDING
                          </div>
                        ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
                          props.dinerInfo &&
                          props.dinerInfo.payment_status !== undefined &&
                          props.dinerInfo.payment_status !== null &&
                          props.dinerInfo.payment_status === 1 ? (
                          <div className="enSuccessLBL text-capitalized">
                            COMPLETED
                          </div>
                        ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
                          props.dinerInfo &&
                          props.dinerInfo.payment_status !== undefined &&
                          props.dinerInfo.payment_status !== null &&
                          props.dinerInfo.payment_status === 2 ? (
                          <div className="enCancelledLBL text-capitalized">
                            CANCELLED
                          </div>
                        ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
                          props.dinerInfo &&
                          props.dinerInfo.payment_status !== undefined &&
                          props.dinerInfo.payment_status !== null &&
                          props.dinerInfo.payment_status === 3 ? (
                          <div className="enCancelledLBL text-capitalized">
                            FAILURE
                          </div>
                        ) : props.dinerInfo &&
                          props.dinerInfo.payment_status !== undefined &&
                          props.dinerInfo.payment_status !== null &&
                          props.dinerInfo.payment_status === 0 ? (
                          <div
                            onClick={() => onPayNowClick(props.dinerInfo)}
                            className="enPendingLBLSmall text-capitalized"
                          >
                            PENDING
                          </div>
                        ) : null}

                        <div className="f11-500 mt-2">
                          {props.dinerInfo &&
                          props.dinerInfo.payment_data &&
                          props.dinerInfo.payment_data.payment_method !==
                            undefined &&
                          props.dinerInfo.payment_data.payment_method !== null
                            ? props.dinerInfo.payment_data.payment_method === 0
                              ? "Cash"
                              : props.dinerInfo.payment_data.payment_method ===
                                1
                              ? "BHIM UPI"
                              : props.dinerInfo.payment_data.payment_method ===
                                2
                              ? "PayTM"
                              : props.dinerInfo.payment_data.payment_method ===
                                3
                              ? "Debit Card"
                              : props.dinerInfo.payment_data.payment_method ===
                                4
                              ? "Credit Card"
                              : props.dinerInfo.payment_data.payment_method ===
                                5
                              ? "Net Banking"
                              : props.dinerInfo.payment_data.payment_method ===
                                6
                              ? "Pay Later"
                              : ""
                            : ""}
                        </div>
                      </div>
                    </td>
                  )}
                  {/* <td style={{ width: extra ? "8%" : "15%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.seating_preference[0]}
                    </h4>
                  </td> */}
                  <td style={{ width: "35%" }}>
                    <div
                      className={
                        props.displayButton === true
                          ? "action-section-body d-flex align-items-center justify-content-center"
                          : "action-section-body align-items-center justify-content-center"
                      }
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                      }}
                    >
                      {/* {props.dinerInfo.diner_status === "SEATED" ? (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Request Unseat"
                            display={true}
                            reasonText="Are you sure to Unseat ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Request Cancel"
                            reasonText="Are you sure to Cancel ?"
                            dataSend={props.dinerInfo._id}
                          />
                        </div>
                      )} */}
                      {props.pathname === "/offline-events-rsvp" &&
                      props.dinerInfo.event_status === "PENDING" ? (
                        <AllActionPopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"rsvpReject"}
                          buttonText="Reject"
                          bigText="Request Reject"
                          reasonText="Are you sure to Reject ?"
                          dataSend={props.dinerInfo}
                        />
                      ) : props.pathname === "/offline-events-rsvp" &&
                        props.dinerInfo.event_status === "NOTSEATED" ? (
                        <AllActionPopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall="rsvpCancel"
                          buttonText="Cancel"
                          bigText="Request Cancel"
                          reasonText="Are you sure to Cancel ?"
                          dataSend={props.dinerInfo}
                        />
                      ) : props.pathname === "/offline-events-rsvp" &&
                        props.dinerInfo.event_status === "SEATED" ? (
                        <AllActionPopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="seatingUnseated"
                          buttonText="Unseat"
                          bigText="Request Unseat"
                          display={true}
                          reasonText="Are you sure to Unseat ?"
                          dataSend={props.dinerInfo}
                          // subscription_id={props.subscription_id}
                        />
                      ) : (props.pathname === "/offline-events-rsvp" &&
                          props.dinerInfo.event_status === "COMPLETED") ||
                        (props.pathname === "/offline-events-rsvp" &&
                          props.dinerInfo.event_status === "REJECTED") ||
                        (props.pathname === "/offline-events-rsvp" &&
                          props.dinerInfo.event_status === "CANCELLED") ? (
                        <AllActionPopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="historyReset"
                          buttonText="Reset"
                          bigText="Request Reset"
                          reasonText="Are you sure to Reset ?"
                          dataSend={props.dinerInfo}
                          // subscription_id={props.subscription_id}
                        />
                      ) : null}
                      <div className="middle-timer">
                        <p className="font_12_r">Total Wait time</p>
                        <div className="count-down-timer d-flex">
                          <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i>
                          <p className="font_16_m">
                            {props.dinerInfo.event_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </p>
                        </div>
                        <p className="font_20_r">
                          Status:&nbsp;
                          <span className="font_20_b">
                            {/* {props.dinerInfo.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"} */}
                            {props.dinerInfo.event_status}
                          </span>
                        </p>
                      </div>
                      {props.pathname === "/offline-events-rsvp" &&
                      props.dinerInfo.event_status === "PENDING" ? (
                        // <AllActionPopup
                        //   buttonDisplay="acceptButtonReservation"
                        //   // displayPopup="acceptButtonReservation"
                        //   buttonText="Accept"
                        //   bigText="Request Accept"
                        //   reasonText="Are you sure you want to accept ?"
                        //   dataSend={props.dinerInfo}
                        // />

                        // <EditWaitTime
                        //   buttonText="Accept"
                        //   editButtonStatus="pendingEdit"
                        //   closedMainModal={onCloseModal}
                        //   allDataProps={props.dinerInfo._id}
                        // />
                        <AllActionPopup
                          buttonDisplay="acceptButtonReservation"
                          // displayPopup="acceptButtonReservation"
                          actionButton="acceptPendingButton"
                          diffrenceTime={diff}
                          buttonText="Accept"
                          bigText="Request Accept"
                          reasonText="Are you sure you want to accept ?"
                          dataSend={props.dinerInfo}
                        />
                      ) : props.pathname === "/offline-events-rsvp" &&
                        props.dinerInfo.event_status === "NOTSEATED" ? (
                        <EnterTableNumber
                          buttonText="Seat"
                          actionBy="RsvpTable"
                          enterTableModal={enterTableModal}
                          eventId={props.dinerInfo}
                          setTablePopUp={setTablePopUp}
                          setTablePopUpClose={setTablePopUpClose}
                          closedMainModal={onCloseModal}
                          allDataProps={props.dinerInfo._id}
                        />
                      ) : props.pathname === "/offline-events-rsvp" &&
                        props.dinerInfo.event_status === "SEATED" ? (
                        <AllActionPopup
                          buttonDisplay="seatingCompleted"
                          displayPopup="seatingCompleted"
                          buttonText="Complete"
                          bigText="Request Complete"
                          reasonText="Are you sure to Completed ?"
                          dataSend={props.dinerInfo}
                          // subscription_id={props.subscription_id}
                        />
                      ) : null}
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="sd_accordion_body">
                    <td className="sd_accordion_td_1">
                      <h4 className="font_20_m c_red">More details</h4>
                      <div className="d-flex justify-content-between mt-3 mr-3">
                        {props.displayCall === true ? (
                          <CallingButtonPopup
                            buttonClass="smallButton"
                            sendData={props.dinerInfo}
                          />
                        ) : null}
                        {props.displaySms === true ? (
                          <SendSmsButton
                            dataSend={props.dinerInfo}
                            buttonClass="smallButton"
                            actionBy="RsvpEvent"
                          />
                        ) : null}
                        {props.displayNotification === true ? (
                          <NotificationButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                            actionBy="RsvpEvent"
                          />
                        ) : null}
                        {props.displayChat === true ? (
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={props.openChatWindow}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/forum.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                        ) : null}
                        {props.displayViewDiner === true ? (
                          // <ViewButtonPopup
                          //   dataSend={props.dinerInfo}
                          //   buttonClass="smallButton"
                          // />
                          <ViewRsvpOfflineEvent
                            dataSend={props.dinerInfo}
                            pathname="/offline-events-rsvp"
                          />
                        ) : null}
                        {props.displayEditDiner === true ? (
                          <EditRsvpOfflineEvent
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                            bigText="Edit Diner"
                            pathname="/offline-events-rsvp"
                          />
                        ) : null}
                      </div>
                    </td>
                    <td className="sd_accordion_td_2">
                      <h4 className="font_20_m">Track User Locon</h4>
                      <LocationReusable dataSend={props.dinerInfo} />
                    </td>
                    {/* <td className="sd_accordion_td_3">
                      <h4 className="font_20_m">Date & Time</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {moment(
                            props.dinerInfo && props.dinerInfo.createdAt
                          ).format("Do MMM, YYYY")}
                          <br />
                          {moment(
                            props.dinerInfo && props.dinerInfo.createdAt
                          ).format("hh:mm A")}
                        </p>
                      </div>
                    </td> */}
                    <td className="sd_accordion_td_4">
                      <h4 className="font_20_m">Table / Room No</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          Room No. -{" "}
                          {props.dinerInfo.room_number === null && undefined
                            ? ""
                            : props.dinerInfo.room_number}
                        </p>
                        <p className="font_16_r">
                          Table No. - {console.log(props.dinerInfo)}
                          {props.dinerInfo.event_type === "RSVP"
                            ? props.dinerInfo && props.dinerInfo.table_number
                            : props.dinerInfo &&
                              props.dinerInfo.seat_number.map((data, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {data},
                                  </React.Fragment>
                                );
                              })}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_5">
                      <h4 className="font_20_m">Special Occasion</h4>
                      <div className="d-flex mt-3">
                        <div id="read-more-text" className="f12-500">
                          <ReadMoreReact
                            text={props.dinerInfo && props.dinerInfo.occasion}
                            min={0}
                            ideal={0}
                            max={
                              props.dinerInfo && props.dinerInfo.occasion.length
                            }
                            readMoreText={"Read More"}
                          />
                        </div>
                      </div>
                    </td>
                    <td className="sd_accordion_td_6">
                      <h4 className="font_20_m">Status</h4>
                      <div className="d-flex mt-3">
                        <div
                          className={`${
                            props.dinerInfo.event_status === "NOTSEATED"
                              ? "b_c_orange"
                              : props.dinerInfo.event_status === "SEATED"
                              ? "b_c_light_green"
                              : props.dinerInfo.event_status === "CANCELLED" ||
                                props.dinerInfo.event_status === "REJECTED"
                              ? "b_c_red"
                              : props.dinerInfo.event_status === "COMPLETED"
                              ? "b_c_green"
                              : "b_c_orange"
                          } status_blink_box`}
                        ></div>
                        <p className="font_16_m">
                          {props.dinerInfo.event_status}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export default OfflineEventTableBody;

// {props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                         props.dinerInfo &&
//                         props.dinerInfo.payment_data &&
//                         props.dinerInfo.payment_data.payment_method !==
//                           undefined &&
//                         props.dinerInfo.payment_data.payment_method !== null &&
//                         props.dinerInfo.payment_data.payment_method === 6 ? (
//                           <div
//                             onClick={() => onPayNowClick(props.dinerInfo)}
//                             className="enCancelledLBL text-capitalized"
//                           >
//                             Pay Now
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 0 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 1 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 2 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 3 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 4 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : props.dinerInfo.event_type === "TICKET_BOOKED" &&
//                           props.dinerInfo &&
//                           props.dinerInfo.payment_data &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             undefined &&
//                           props.dinerInfo.payment_data.payment_method !==
//                             null &&
//                           props.dinerInfo.payment_data.payment_method === 5 ? (
//                           <div className="enSuccessLBL text-capitalized">
//                             Paid
//                           </div>
//                         ) : (
//                           <div className="enCancelledLBL text-capitalized">
//                             {props.dinerInfo.payment_status}
//                           </div>
//                         )}
